module.exports = __webpack_public_path__ + "img/diamond-1.ebfdf38f.png";